import * as React        from "react";

import "./warning-mailing-list-modal.scss";

import {cs}                         from "@Common/react/chain-services";
import {MLWarningTable}             from "@Common/ui-components/heavy/mailing-ui/ml-warning-table/ml-warning-table";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const WarningMailingListModal = ({entityId, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3<any>({
        contentService: ({params: {mailingLists, resolve}, close, next: next1}) => next1({
            getContent: () => next({
                mailingLists,
                close: (value) => {
                    close();
                    resolve(value);
                },
            }),
            onPassiveClose: () => resolve(false),
        }),
        xdQaName: "Warning Mailing List",
        rootNext: (modal) => rootNext({
            show: (args) => new Promise((resolve) => {
                modal.show({...args, resolve});
            }),
        }),
    })],
    ({modal}) => (
        <div className="warning-mailing-list-modal-42b">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Edit Mailing List">
                    <img src='/next_images/Address-Warning.svg'/> 
                    <div className="title-message">Confirm List(s)</div>
                </div>
            </div>
            
            <div className="content">
                <div className="header">                    
                    <div className="text">The following list(s) contain addresses that can't be validated, and might be at risk of not reaching the recipient.</div>
                    <div className="infoMessage">Confirm to continue, or click the edit icon for more details and updates.</div>
                    
                </div>
                <div className="box">
                    {MLWarningTable({
                        entityId,
                        mailingLists: modal.mailingLists,
                        loading: false,
                        xdQaNamePrefix:"warning",
                    })}
                </div>
            </div>

            <div className="footer">
            <div className="warningMessage">Xpressdocs is not responsible for undelivered mail to at risk addresses</div>
            <div className="bufferDiv"></div>
                <button {...{
                    className: "cancel",
                    onClick: () => modal.close(false),
                    "xd-qa-type": "button",
                    "xd-qa-name": "Cancel",
                }}>
                    Back
                </button>

                <button {...{
                    className: "next",
                    onClick: () => {
                        modal.close(true)
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Continue Order",
                }}>
                    Confirm
                </button>
            </div>
        </div>
    )
);